import { render } from "./CloseButton.vue?vue&type=template&id=6473fe34&scoped=true"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"

import "./CloseButton.vue?vue&type=style&index=0&id=6473fe34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6473fe34"]])

export default __exports__